import { Outlet } from 'react-router-dom';

import { ErrorPopUp } from '../ErrorPopUp/ErrorPopUp';
import { usePopstateRefetch } from '../hooks/usePopstateRefetch';
import { SessionExpiredModalWrapper } from '../SessionExpired/SessionExpiredWrapper';
import BonusInfoContainer from './BonusInfo';
import Header from './Header/Header';
import { Tabs } from './Tabs';

const Layout = () => {
  usePopstateRefetch();

  return (
    <>
      <Header />
      <SessionExpiredModalWrapper />
      <ErrorPopUp />
      <BonusInfoContainer />
      <Tabs />
      <Outlet />
    </>
  );
};

export default Layout;
